import React from "react";
import ReactDOM from "react-dom";
import "regenerator-runtime/runtime";
import * as Flex from "@twilio/flex-ui";
import "./index.css";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import Logout from "./Logout";

// let parentUrl = window.appConfig.sfwyUrl;
let parentUrl = "*";
const params = new URLSearchParams(window.location.search);

console.log('Query Params: ' + params);
console.log(params.get("parentInstance"));
if(params.get("parentInstance") === 'PUBLIX') {
  // parentUrl = window.appConfig.pubxUrl;
}
console.log("index.js -> Parent Url: ", parentUrl);

const mountNode = document.getElementById("root");
document.title = "RX Copilot";
window.onload = () => {
  /*** Loader */
  const outloader = document.createElement("div");
  outloader.className = "out-loader"; 
  const loader = document.createElement("div");
  loader.className = "loader";
  outloader.appendChild(loader);
  mountNode.appendChild(outloader);

  const predefinedConfig = window.appConfig || {};
  const checkPopupBlocked = () => {
    const testPopup = window.open("", "_blank", "width=1,height=1");
    if (testPopup === null) {
      return false;
    } else {
      testPopup.close();
      return true;
    }
  };
  if (window.opener && !window.opener.closed) {
    
    // console.log("This URL is opened in a subwindow (popup).");
    // Handle subwindow-specific logic here
  } else if (window.self !== window.top) {
    // console.log("This URL is opened in an iframe.");
    if (!checkPopupBlocked()) {
      const jsonData = {
        app: "Rxcopilot",
        action: "flex",
      };
      window.parent.postMessage(
        jsonData,
        parentUrl
      );
      alert("Please enable pop-ups to use Voice Call");
  
      return;
    }
  } 
  
if(!window.location.href.includes("logout")){
  const configuration = {
    ...predefinedConfig,
  };

  Flex
    .progress(mountNode)
    .provideLoginInfo(configuration, mountNode)
    .then(() => Flex.Manager.create(configuration))
    .then(manager => renderApp(manager))
    .catch(error => handleError(error));
  } else {
    ReactDOM.render(
      <Logout parentUrl={parentUrl} />,
      mountNode
    );
  };

  function renderApp(manager) {
    ReactDOM.render(
      <App manager={manager} />,
      mountNode
    );
  }
    
}

function handleError(error) {
  const errorMessage = error?.message || "";
  if(errorMessage === 'Log in failed. Please contact your administrator and try again later.' ||
    errorMessage === 'We\'re not able to log you in right now - this might be due to an ongoing incident we\'re experiencing. Contact your administrator and try again later.'
  ) {
    const jsonData = {
      /*** 7116 */
      app: "Rxcopilot",
      action: "contact-center-login-closed",
    };

    window.parent.postMessage(
      jsonData,
      parentUrl
    );
  } else {
    const jsonData = {
      /*** 7116 */
      app: "Rxcopilot",
      action: "c-contact-sso-fail",
    }
    window.parent.postMessage(
      jsonData,
      parentUrl
    )
    console.error("Failed to initialize", error);
    Flex.errorPage(error, mountNode);
  }
}

registerServiceWorker();
